import axios from 'axios'

export const fetchProfilePatterns = () => axios.get('/profilepattern')
